// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./static/fonts/font.css
// module id = 875
// module chunks = 41